import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import FormItemContainer from '../Global/Containers/FormItemContainer';
import _get from 'lodash/get';
import { Field } from 'formik';

import OutlinedSelectInput from '../Global/Inputs/OutlinedSelect';
import TextFieldInput from '../Global/Inputs/TextField';
import { COUNTRIES, STATES } from '../../constants/dropdowns';
import Grid from '@material-ui/core/Grid';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import { SHIPMENT_DIRECTION } from '../../constants/constants';

const styles = theme => ({
  locationContainer: {
    paddingTop: theme.spacing.unit * 0.75,
    paddingBottom: theme.spacing.unit * 2
  }
});

const COUNTRY_US = 'US';

export class Location extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['pickup', 'delivery']).isRequired,
    handleValidateField: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    defaultZip: PropTypes.string
  };

  componentDidUpdate(prevProps) {
    const { setFieldValue, values, defaultZip } = this.props;

    if (
      prevProps.values.shipmentDirectionId !==
      this.props.values.shipmentDirectionId
    ) {
      switch (values.shipmentDirectionId) {
        case SHIPMENT_DIRECTION.OUTBOUND:
        case SHIPMENT_DIRECTION.SHUTTLE:
          setFieldValue('pickup.locationAddress.postalCode', defaultZip);
          setFieldValue('delivery.locationAddress.postalCode', '');
          break;
        case SHIPMENT_DIRECTION.INBOUND:
          setFieldValue('pickup.locationAddress.postalCode', '');
          setFieldValue('delivery.locationAddress.postalCode', defaultZip);
          break;
        case SHIPMENT_DIRECTION.DROP:
          setFieldValue('pickup.locationAddress.postalCode', '');
          setFieldValue('delivery.locationAddress.postalCode', '');
          break;

        default:
      }
    }

    if (
      this.props.values[this.props.type].locationAddress.country ===
        COUNTRY_US &&
      prevProps.values[this.props.type].locationAddress.country !== COUNTRY_US
    ) {
      // They switched from Mexico which is the only one that needs city/state so clear those out so we don't send them
      setFieldValue(`${this.props.type}.locationAddress.state`, null);
      setFieldValue(`${this.props.type}.locationAddress.city`, null);
    }
  }

  render() {
    const {
      t,
      type,
      name,
      classes,
      values,
      handleChange,
      handleValidateField
    } = this.props;

    return (
      <FormItemContainer
        title={name}
        classes={{ container: classes.noMarginBottom }}
      >
        <Grid
          container
          spacing={16}
          classes={{ container: classes.locationContainer }}
        >
          <Grid item xs={6} lg={6}>
            <Field
              name={`${type}.locationAddress.country`}
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <OutlinedSelectInput
                    value={_get(values, `${type}.locationAddress.country`, '')}
                    field={field}
                    form={form}
                    label={t('Country')}
                    options={COUNTRIES}
                    multiple={false}
                    validateField={handleValidateField}
                  />
                );
              }}
            />
          </Grid>
          {_get(values, `${type}.locationAddress.country`, '') !==
            COUNTRY_US && (
            <Fragment>
              <Grid item xs={6}>
                <Field
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <TextFieldInput
                        label={t('City')}
                        name={`${type}.locationAddress.city`}
                        value={_get(values, `${type}.locationAddress.city`, '')}
                        validateField={handleValidateField}
                        field={field}
                        form={form}
                      />
                    );
                  }}
                />
              </Grid>
              <Grid item xs={6} lg={6}>
                <Field
                  name={`${type}.locationAddress.state`}
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <OutlinedSelectInput
                        value={_get(
                          values,
                          `${type}.locationAddress.state`,
                          ''
                        )}
                        field={field}
                        form={form}
                        label={t('State')}
                        options={
                          STATES[
                            _get(values, `${type}.locationAddress.country`)
                          ]
                        }
                        multiple={false}
                        validateField={handleValidateField}
                      />
                    );
                  }}
                />
              </Grid>
            </Fragment>
          )}
          <Grid item xs={6}>
            <Field
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <TextFieldInput
                    label={t('ZIP')}
                    name={`${type}.locationAddress.postalCode`}
                    value={_get(
                      values,
                      `${type}.locationAddress.postalCode`,
                      ''
                    )}
                    validateField={handleValidateField}
                    field={field}
                    form={form}
                  />
                );
              }}
            />
          </Grid>
        </Grid>
      </FormItemContainer>
    );
  }
}

const LocationWithTranslation = withNamespaces()(Location);
export default withStyles(
  combineStyles(LayoutStyles, TypographyStyles, SpacingStyles, styles)
)(LocationWithTranslation);
